<div class="card-head" *ngIf="firstTime">
  <h1>{{ 'auth.Set-password' | translate }}</h1>
  <h3>{{ 'auth.Reset-title' | translate }}</h3>
</div>
<div class="card-head" *ngIf="!firstTime">
  <h1>{{ 'auth.Reset-password' | translate }}</h1>
  <h3>{{ 'auth.Reset-title' | translate }}</h3>
</div>


<div *ngIf='dataLoading' class="dataLoading py-5">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<div *ngIf="!dataLoading">
  <ng-container *ngIf="linkValid">
      <form [formGroup]="setPasswordForm" (ngSubmit)='resetPassword()'>
      <mat-form-field class="form-group mb-5">
        <mat-label>{{ 'forms.Password' | translate }}</mat-label>
        <input matInput formControlName="password" autocomplete="off" [type]="hidePassword ? 'password' : 'text'"
          maxlength="50" required>
        <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
          [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
          <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-hint class="password-hint">{{ 'auth.password-validation' | translate }}</mat-hint>
        <mat-error *ngIf="hasError('password', 'required')">{{ 'forms.Required' | translate }}</mat-error>
        <mat-error *ngIf="hasError('password', 'pattern')">{{ 'auth.password-validation' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field class="form-group mb-5">
        <mat-label>{{ 'forms.Confirm Password' | translate }}</mat-label>
        <input matInput formControlName="confirmPassword" autocomplete="off" [type]="hidePassword ? 'password' : 'text'"
          maxlength="50" required>
        <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
          [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
          <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-hint class="password-hint">{{ 'auth.password-validation' | translate }}</mat-hint>
        <mat-error *ngIf="hasError('confirmPassword', 'required')">{{ 'forms.Required' | translate }}</mat-error>
        <mat-error *ngIf="hasError('confirmPassword', 'pattern')">{{ 'auth.password-validation' | translate }}</mat-error>
      </mat-form-field>

      <div *ngIf="passwordMatchError" class="has-error mb-4">
        {{'auth.Password does not match!' | translate}}
      </div>

      <div class="btn-container mb-3">
        <button mat-raised-button color="primary" class="w-100" [disabled]='loading' [class.loading]='loading'>
          <span *ngIf="firstTime">{{ 'auth.Set-password' | translate}}</span>
          <span *ngIf="!firstTime">{{ 'auth.Reset-password' | translate}}</span>
        </button>
      </div>

    </form>
    </ng-container>

    <div class="mb-5" *ngIf="!linkValid">
      <h4 class="text-center text-danger">{{ 'auth.Reset-expire' | translate }}</h4>
    </div>
  </div>

  <div class="card-action">
    <a [routerLink]="['/login']">{{ 'auth.Login' | translate }}</a>
  </div>
